import React, { Component } from 'react';
import ReactPlayer from 'react-player';
import ReactModal from 'react-modal';
import { history } from '../helpers';
import { LANG, LANG_SPECIFICS } from '../common/constants';
import { strings } from '../common/translations';
import {
    Header, Image, Grid, Menu, Button
} from 'semantic-ui-react';

import iconAltaFormazione from '../images/icons/alta-formazione.svg'
import iconRicercaInnovazione from '../images/icons/ricerca-innovazione.svg'
import iconRetiCollaborazione from '../images/icons/reti-collaborazione.svg'
// import iconTOR from '../images/icons/tor.svg'
import { FaTimes } from 'react-icons/fa';
import { FaFileVideo } from 'react-icons/fa';
import { FiExternalLink } from 'react-icons/fi';

import Particles from 'react-particles-js';

ReactModal.setAppElement('#root')

class Home extends Component {

    constructor() {
        super();
        this.state = {
            menuOptions: [
                {
                    name: strings.NAVIGATION.SECTION_1.URL,
                    text: strings.NAVIGATION.SECTION_1.NAME,
                    image: iconAltaFormazione
                },
                {
                    name: strings.NAVIGATION.SECTION_2.URL,
                    text: strings.NAVIGATION.SECTION_2.NAME,
                    image: iconRicercaInnovazione
                },
                {
                    name: strings.NAVIGATION.SECTION_3.URL,
                    text: strings.NAVIGATION.SECTION_3.NAME,
                    image: iconRetiCollaborazione
                }
            ],
            showModal: false,
            activeVideo: 'videos/visualizzazioni-alta-formazione.mov'
        }
        strings.setLanguage(LANG);
        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    handleSectionClick = (e, { name }) => {
        this.setState({ activeItem: name })
        history.push(`/` + name);
    }

    handleOpenModal(videoURL) {
        this.setState({ showModal: true, activeVideo: videoURL });
    }

    handleCloseModal() {
        this.setState({ showModal: false });
    }

    render() {

        return <div className='section home'>

            <div className="bg-full bg-animation">
                <Particles />
            </div>
            <ReactModal
                isOpen={this.state.showModal}
                contentLabel="Case"
            >
                <div className="modal-fake">

                    <div className="container-fluid border d-flex">
                        <Button className="ml-auto" color='black' onClick={this.handleCloseModal}><FaTimes /></Button>
                    </div>
                    <div className="container border">
                        <ReactPlayer width='100%' height="100%" controls={true} url={[this.state.activeVideo]} />
                    </div>
                </div>
            </ReactModal>
            <div className='placeholder-left'>
                <Header as='h1'>
                    {strings.HOME.TITLE}
                </Header>
                <p className="section_description">
                <FiExternalLink /> <span><a className="text-white" rel="noopener noreferrer" href={strings.COMMON.MANUAL_URL} target="_blank">{strings.COMMON.MANUAL}</a></span>
                </p>
            </div>

            <div className="placeholder-right">
                <Grid columns={2} className="h-100 m-0">
                    <Grid.Row className="h-75 p-0 w-background mb-0">
                        <Grid.Column width={12} className='pt-5 pl-5'>
                            <Header as="h2">
                                {strings.HOME.BOX.TITLE}
                            </Header>
                            <p>{strings.formatString(strings.HOME.BOX.TEXT, <a href={LANG_SPECIFICS[LANG].HOME_LINK} target="_blank" rel="noopener noreferrer">{strings.HOME.BOX.LINK_TEXT}</a>)}</p>
                        </Grid.Column>
                        <Grid.Column width={4} className="pr-0">
                            <Menu vertical inverted className='h-100 w-100 d-flex'>
                                {
                                    this.state.menuOptions.map((item, index) => {
                                        return <Menu.Item key={index} onClick={this.handleSectionClick} name={item.name} className='p-0 flex-fill'>
                                            <Header as='h4' className='p-2 h-100 d-flex flex-wrap justify-content-center align-items-center'>
                                                {item.image && <Image alt={item.text} src={item.image} className='mt-auto home-menu-icon'></Image>}
                                                <span className='text-center text-white w-100'>{item.text}</span>
                                            </Header>
                                        </Menu.Item>
                                    })
                                }
                            </Menu>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row className="h-25">
                        <Grid.Column width={16} className='px-0'>
                            <Button color='red' size='mini' className="mb-1 mr-1" onClick={() => this.handleOpenModal('videos/visualizzazioni-alta-formazione.mov')}><FaFileVideo></FaFileVideo> {strings.HOME.VIDEO.ALTA_FORMAZIONE}</Button>
                            <Button color='red' size='mini' className="mb-1 mr-1" onClick={() => this.handleOpenModal('videos/visualizzazioni-ricerca-e-innovazione.mov')}><FaFileVideo></FaFileVideo> {strings.HOME.VIDEO.RICERCA_INNOVAZIONE}</Button>
                            <Button color='red' size='mini' className="mb-1 mr-1" onClick={() => this.handleOpenModal('videos/visualizzazioni-reti-di-collaborazione.mov')}><FaFileVideo></FaFileVideo> {strings.HOME.VIDEO.RETI_COLLABORAZIONE}</Button>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
           <div className="resolution-disclaimer">
               {strings.HOME.DISCLAIMER}
           </div>
        </div>
    }
}

export default Home;